import { useQuery } from '@tanstack/react-query';
import { fetchQuoteRateResults } from '../data-provider/quote-rate-results';

export const useGetQuoteRates = (quoteKey: string) => {
  return useQuery({
    queryKey: ['spot-quote-rate-results', quoteKey],
    queryFn: () => fetchQuoteRateResults(quoteKey),
    staleTime: 1000 * 60 * 60 * 1, // 1 hour
    enabled: !!quoteKey,
  });
};
